import React from "react";
import cx from "classnames";
import styles from "./Intro.module.scss";
import Image from "@components/Image";
import _ from "lodash";
const Item = ({
  data,
}: {
  data: {
    icon: { src: string; alt: string };
    label: string;
    content?: string;
  };
}) => {
  return (
    <div className={cx(styles.item)}>
      <Image
        speed={0}
        wrapperProps={{ className: cx(styles.icon) }}
        src={data?.icon?.src}
        alt={data?.icon?.alt}
        layout="fill"
        objectFit="contain"
      />
      <div className={cx(styles.label)}>{data?.label}</div>
      {/* <div className={cx(styles.content)}>{data.content}</div> */}
    </div>
  );
};

export default function Intro({ data }: any) {
  return (
    <div data-scroll-section className={cx(styles.section)}>
      <div className={cx(styles.overview)}>{_.get(data, "content")}</div>
      <div className={cx(styles.itemsWrapper)}>
        {_.map(_.get(data, "images"), (icon: any, index) => (
          <Item
            key={index}
            data={{
              icon: _.get(icon, "image"),
              label: _.get(icon, "title"),
            }}
          />
        ))}
      </div>
    </div>
  );
}
